import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';

export type ExistingBankConnectionChoice = 'existing' | 'new' | null;

@Component({
    selector: 'app-existing-bank-connection-dialog',
    templateUrl: './existing-bank-connection-dialog.component.html',
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ExistingBankConnectionDialogComponent
{
    @Input() open = false;
    @Input() bankName = '';
    @Output() readonly closed = new EventEmitter<ExistingBankConnectionChoice>();
}
